import {process} from "@progress/kendo-data-query";
import {Button} from "@progress/kendo-react-buttons";
import {Input, TextBox} from "@progress/kendo-react-inputs";
import useClientStore from "../../stores/ClientStore";
import useOwnRightsStore from "../../stores/OwnRightsStore";
import {useEffect, useState} from "react";
import Waiting from "../waiting/Waiting";
import ClientInGrid from "./ClientInGrid";
import useProjectStore from "../../stores/ProjectStore";

const initialDataState = {
    take: 500,
    skip: 0,
};

const Clients = props => {

    const {selectedProject, setSelectedProject} = useProjectStore((state) => ({selectedProject: state.selectedItem, setSelectedProject: state.selectItem}))

    const {selectedClient, setSelectedClient} = useClientStore((state) => ({selectedClient: state.selectedClient, setSelectedClient: state.selectClient}))
    const clients = useClientStore(state => state.clients)
    const isPending = useClientStore(state => state.isLoading)
    const loadClients = useClientStore(state => state.loadClients)

    const setProjects = useProjectStore(state => state.setStoreData)

    const rights = useOwnRightsStore(state => state.storeData)
    const haveRight = useOwnRightsStore(state => state.haveRight)


    useEffect(() => {
        loadClients()
        setSelectedClient(null)
        setProjects(null)
        setSelectedProject(null)
    },[])

    const [dataState, setDataState] = useState(initialDataState);
    const [filter, setFilter] = useState("")

    const useFilter = (e) => {
        setFilter(e.value)

        const newDataState = {
            take: 50,
            skip: 0,
            filter: {
                logic: "or",
                filters: [
                    { field: "Name", operator: "contains", value: e.value },
                    { field: "Representative", operator: "contains", value: e.value },
                    { field: "Phone", operator: "contains", value: e.value },
                    { field: "Address", operator: "contains", value: e.value }
                ]
            }
        };

        setDataState(newDataState)

    }

    const selectClient = client => {
        console.log("select client")
        setSelectedClient(client)
        console.log(selectedClient)
        // setSelectedProject(null)
        // menuSelect(1)
    }
    const closeClient = client => {
        setSelectedClient(null)
    }
    const selectProject = project => {
        // setSelectedProject(project)
    }


    return(
        <>

            {isPending && <Waiting />}

            {clients && haveRight("Clients_Read") && <>

                <div className="clients">

                    <div className="quick-filter">
                        {/*<h3>Hledat klienta:</h3>*/}
                        <TextBox value={filter}
                                 onChange={useFilter}
                                 size={"large"}
                                 style={{
                                     width: "calc(100% - 40px)",
                                     marginBottom: 3,
                                     marginTop: 3,
                                     padding: 0,
                                     color: "#333333",
                                     background: "#DDDDDD",
                                 }}
                        />&nbsp;
                        {/*<div className="client-filter-button">*/}
                        {/*    <Button value={"Nový"}*/}
                        {/*            size={"large"}*/}
                        {/*            themeColor={"error"}*/}
                        {/*    >Nový</Button>*/}
                        {/*</div>*/}
                    </div>

                    <div className="list">
                        {process(clients, dataState).data.map(client => (
                            <ClientInGrid key={client.ID} id={client.ID} client={client} selectClient={selectClient}/>

                        ))}
                    </div>
                </div>
            </>}
        </>
    )
}

export default Clients